import { render, staticRenderFns } from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=template&id=41ff153b&scoped=true"
import script from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=style&index=0&id=41ff153b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ff153b",
  null
  
)

export default component.exports